import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

import { Tag } from '@rikstv/shared-components';

import styles from './ImageOverlayWrapper.module.css';
interface Props extends HTMLAttributes<HTMLDivElement> {
  centerContent?: boolean;
  backdropStyle?: 'none' | 'dark' | 'gradient';
  displayChildrenOnHover?: boolean;
  label?: string;
}
export const ImageOverlayWrapper: FC<Props> = ({
  children,
  centerContent,
  backdropStyle = 'none',
  displayChildrenOnHover,
  className = '',
  label,
  ...rest
}) => {
  const classes = classNames(
    styles.imageOverlayWrapper,
    centerContent && styles.imageOverlayWrapperCenter,
    backdropStyle === 'dark' && styles.imageOverlayWrapperDark,
    backdropStyle === 'gradient' && styles.imageOverlayWrapperGradient,
    displayChildrenOnHover && styles.imageOverlayWrapperShowOnHover,
    className
  );
  return (
    <div className={classes} {...rest}>
      {children}
      {label && <Tag className={styles.imageOverlayTitle}>{label}</Tag>}
    </div>
  );
};
